export default {"src":"/_next/static/media/chevron-right-primary-purple.b043c188.svg","height":18,"width":12,"blurWidth":0,"blurHeight":0};